module.exports = __webpack_public_path__ + "img/4.34718b51.png";